import { render, staticRenderFns } from "./TableDetail.vue?vue&type=template&id=5bfebd69&scoped=true&"
import script from "./TableDetail.vue?vue&type=script&lang=js&"
export * from "./TableDetail.vue?vue&type=script&lang=js&"
import style0 from "./TableDetail.vue?vue&type=style&index=0&id=5bfebd69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfebd69",
  null
  
)

export default component.exports